<template>
  <div class="footprint-wrapper">
    <div v-if="!preloaderVisibility">
      <div class="footprint-wrapper-top">
        <h2>{{ total }} Results</h2>
        <FootprintTableAddButton
            :items-groups="itemsGroups"
        />
      </div>
      <div class="footprint-wrapper-sorting">
        <FootprintTableSorting
            :sortingData="sortingData"
        />
      </div>
      <div class="footprint-wrapper-table">
        <FootprintTableList
            :footprints="footprints"
        />
      </div>
    </div>
    <PreloaderComponent
        v-if="preloaderVisibility"
    />
    <div class="footprint-wrapper-navigation">
      <div>
        <FootprintTablePrevButton
            @on-prev-button-click="handleNavigationButtonClick"
            v-if="!preloaderVisibility"
            :offset="searchParams.offset"
            :limit="searchParams.limit"
        />
      </div>
      <div>
        <FootprintTableNextButton
            @on-next-button-click="handleNavigationButtonClick"
            v-if="!preloaderVisibility"
            :offset="searchParams.offset"
            :limit="searchParams.limit"
            :maxItems="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SolFileAPIInstance from '@/api'

import PreloaderComponent from '@/components/common/PreloaderComponent'
import FootprintTableList from '@/components/FootprintTable/FootprintTableList'
import FootprintTableAddButton from '@/components/FootprintTable/FootprintTableAddButton'
import FootprintTableSorting from '@/components/FootprintTable/FootprintTableSorting/FootprintTableSorting'
import FootprintTableNextButton from '@/components/FootprintTable/FootprintTableNextButton'
import FootprintTablePrevButton from '@/components/FootprintTable/FootprintTablePrevButton'

export default {
  name: "FootprintTable",
  data() {
    return {
      footprints: [],
      searchParams: {
        offset: 0,
        limit: 10,
        code_key: null,
        star_sign: null,
        wos: null
      },
      preloaderVisibility: true,
      sortingData: [],
      sortingParameters: {},
      itemsGroups: {},
      total: 0
    }
  },
  components: {
    FootprintTableList,
    PreloaderComponent,
    FootprintTableSorting,
    FootprintTableAddButton,
    FootprintTableNextButton,
    FootprintTablePrevButton
  },
  methods: {

    async fetchDiscoveryKeys() {
      const response = await SolFileAPIInstance.getFootprintKeysList()
      if (response.data) {
        const data = {...response.data}
        this.itemsGroups = data
        this.sortingData = Object.values(data).reduce((acc, item) => {
          acc.code_key.values = [...new Set([...acc.code_key.values, ...item.code_key])]
          acc.star_sign.values = item.star_sign ? [...new Set([...acc.star_sign.values, ...item.star_sign])] : acc.star_sign.values
          acc.wos.values = [...new Set([...acc.wos.values, ...item.wos])]
          return acc
        }, {
          code_key: {
            selectedValue: null,
            values: []
          },
          star_sign: {
            selectedValue: null,
            values: []
          },
          wos: {
            selectedValue: null,
            values: []
          }
        })
      }
    },

    handleNavigationButtonClick(offset) {
      this.searchParams.offset = offset
      this.fetchDiscoveries()
    },

    async fetchDiscoveries() {
      this.preloaderVisibility = true
      const response = await SolFileAPIInstance.getFootprintList(this.searchParams)
      if (response.data) {
        this.footprints = response.data.footprints
        this.total = response.data.total
        this.preloaderVisibility = false
      }
    }

  },

  watch: {
    sortingData: {
      deep: true,
      handler() {
        Object.entries(this.sortingData).forEach(item => {
          const [label, value] = item
          this.searchParams = {
            ...this.searchParams,
            [label]: value.selectedValue
          }
        })
        this.searchParams.offset = 0;
        this.fetchDiscoveries()
      }
    }
  },

  mounted() {
    this.fetchDiscoveryKeys()
  }

}
</script>

<style scoped lang="scss">

.footprint-wrapper {
  padding: 25px;

  &-table {
    margin-top: 20px;
  }

  &-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.footprint-wrapper-navigation {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

</style>